import { Box, Button, Grid, Typography } from "@mui/material";
import Header from "../../components/Header/Header";
import './TrialPage.css';
import SamplePDF from '../../assets/files/sample.pdf';
import { useContext, useState } from "react";
import UploadFileModal from "../../components/QuizComponents/Modals/UploadFileModal/UploadFileModal";
import ManualModal from "../../components/QuizComponents/Modals/ManualModal/ManualModal";
const navLinks = [];
function TrialPage() {
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [isManualModalOpen, setIsManualModalOpen] = useState(false);
    
    const handleDownloadSample = () => {
        const link = document.createElement('a');
        link.href = SamplePDF;
        link.download = 'EDUWaves_Sample.pdf';
        link.click();
    };

    

    return (
        <>
            <Header navLinks={navLinks} isScrollEffect={false} />
            <Box className="page-container">
                <Typography className="page-title" variant="h3" gutterBottom>
                    Explore the Free Trial
                </Typography>
                <Typography className="page-subtitle" variant="h5" gutterBottom>
                    Your first step toward interactive learning
                </Typography>
                <Typography className="page-description" paragraph>
                    Experience EDUWaves' powerful features by creating your first Assessment during the free trial. 
                    Choose between two flexible options:
                    <ul>
                        <li>
                            <strong>Upload a PDF:</strong> We'll process your file to extract and organize your questions, allowing you to review them before proceeding.
                        </li>
                        <li>
                            <strong>Build from Scratch:</strong> Manually create your Assessment directly on the platform with our intuitive tools.
                        </li>
                    </ul>
                </Typography>

                <Typography className="important-note" paragraph>
                    <strong>For best results when uploading a PDF:</strong>
                    <ul>
                        <li>Use numbers like <code>1.</code>, <code>2.</code>, <code>3.</code> to organize your questions sequentially.</li>
                        <li>Ensure any images appear immediately below the associated question text.</li>
                        <li>If questions have choices, list them using letters like <code>A.</code>, <code>B.</code>, <code>C.</code>.</li>
                        <li>(Optional) Include the correct answer by using the format <strong>"Correct: Answer"</strong>.</li>
                        <li>For subquestions, use a format like <strong>"Subquestions for question x:"</strong> followed by <code>1-</code>, <code>2-</code>, <code>3-</code>.</li>
                    </ul>   
                </Typography>

                <Typography className="download-prompt" paragraph>
                    Need guidance? <span className="text-button" onClick={handleDownloadSample}> Download our <strong>sample PDF</strong> for a detailed example. </span> 
                </Typography>
                {/* <Button
                    className="download-button"
                    onClick={handleDownloadSample}
                    variant="contained"
                    size="large"
                >
                    Download Sample PDF
                </Button> */}
                {/* <DownloadCard
                    fileUrl={SamplePDF}
                    fileName="EDUWaves_Sample.pdf"
                    description="A sample PDF demonstrating the recommended format and structure for uploading your quizzes."
                /> */}

                <Grid container spacing={2} className="actions-container">
                    <Grid item>
                    <Button
                        className="primary-button"
                        onClick={() => setIsUploadModalOpen(true)}
                        variant="contained"
                        size="large"
                    >
                        Upload PDF
                    </Button>

                    </Grid>
                    <Grid item>
                        <Button
                            className="secondary-button"
                            onClick={() => setIsManualModalOpen(true)}
                            variant="outlined"
                            size="large"
                        >
                            Build Manually
                        </Button>
                    </Grid>
                </Grid>
                <UploadFileModal 
                    open={isUploadModalOpen} 
                    onClose={() => setIsUploadModalOpen(false)} 
                />
                <ManualModal 
                    open={isManualModalOpen} 
                    onClose={() => setIsManualModalOpen(false)} 
                />

            </Box>
        </>
    );
}

export default TrialPage;
